import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Style/Footer/Footer.css";
import axios from "axios";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";
import PinterestIcon from "@mui/icons-material/Pinterest";
import PersonIcon from "@mui/icons-material/Person";

import { useLocation } from "react-router-dom"; // ⬅️ ADD THIS

// ⬅️ ADD THIS ARRAY (list of landing pages where footer sections should be hidden on mobile)
const hideSectionsPages = [
  "/landing-page-domestic-trips",
  "/landing-page-international-trips",
  "/landing-page-nye-trips",
  "/landing-page-nye-domestic-trips",
  "/landing-page-all-trips",
  "/landing-page-nye-international-trips",
  "/landing-page-ladakh-winter-trip",
  "/landing-page-summer-bike-trips",
  "/landing-page-ladakh-summer-trip-2026",
  "/landing-page-kashmir-winter-trip",
  "/newyear-trips"
];

const Footer = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState(null);
  const [destinations, setDestinations] = useState(null);
  const [homeSliders, setHomeSliders] = useState(null);
  const [trips, setTrips] = useState(null);
  const location = useLocation(); // ✅ Add this
  const isMobile = window.innerWidth <= 768; // ✅ Add this
const shouldHideSections = hideSectionsPages.includes(location.pathname);

  // get All Selected Home Page Category
  const getSelectedHomeCategory = () => {
    axios.get(`api/homecategory/get-home-category`).then((res) => {
setDestinations(res?.data?.data?.[0]?.curatedCategory || []);
      setHomeSliders(res.data.data[0]?.top5HomeCategory);
    });
  };
// const getSelectedHomeCategory = () => {
//   axios.get(`api/homecategory/get-home-category`)
//     .then((res) => {
//       const dataArray = res?.data?.data;
//       if (Array.isArray(dataArray) && dataArray.length > 0) {
//         setDestinations(dataArray[0]?.curatedCategory || []);
//         setHomeSliders(dataArray[0]?.top5HomeCategory || []);
//       } else {
//         setDestinations([]);
//         setHomeSliders([]);
//       }
//     })
//     .catch((err) => {
//       console.error("Error fetching footer category:", err);
//       setDestinations([]);
//       setHomeSliders([]);
//     });
// };

  async function getAllBlogs() {
    try {
      const res = await axios.get("/api/blog/get-all-blog");
      if (res.data.success) {
        setBlogs(res.data.data.reverse());
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getAllTrips() {
    try {
      const res = await axios.get("/api/trips/get-all-trips");
      if (res.data.success) {
        setTrips(res.data.data);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getAllBlogs();
    getAllTrips();
    getSelectedHomeCategory();
  }, []);
 return (
    <>
       {/* ✅ Wave Shape (Hidden for landing pages) */}
      {!shouldHideSections && (
        <div className="footer-wave">
          <svg viewBox="0 0 120 28" preserveAspectRatio="none">
            <path
              d="M0 30 V15 Q30 3 60 15 T120 15 V30z"
              fill="#333333"
            ></path>
          </svg>
        </div>
      )}
      {/* Footer Content */}
    {shouldHideSections ? (
  <div
    className="footer text-white Mon_font py-3 lp-footer"
    style={{ borderTop: "1px solid #333" }}
  >
    <div className="container d-flex justify-content-between align-items-center">
      <div>
        <Link
          target="_blank"
          to="https://instagram.com/highmountainsin"
          className="text-white"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <InstagramIcon className="icon" style={{ fontSize: "28px" }} />
          <span className="lp-text">Follow us on Instagram</span>
        </Link>
      </div>
<div className="lp-text footer-phone">
  <Link
    to="tel:+919888823721"
    className="text-white text-decoration-none"
  >
    <span className="footer-phone-label">Contact Number:</span>
    <span className="footer-phone-number">+91 98888 23721</span>
  </Link>
</div>

    </div>
<div className="sticky-chat-wrapper">
  <a
    href="https://wa.me/919888823721"
    target="_blank"
    rel="noopener noreferrer"
    className="sticky-chat-container"
  >
    <div className="chat-icon">
      <PersonIcon className="icon" />
    </div>
    <span className="chat-text">Hii! Chat now  to join the tribe!</span>
  </a>
</div>


  </div>
) : (


        // ✅ Full footer for all other pages
        <div className="footer text-white text-center Mon_font">
          <div className="sticky-wa-icon">
            <Link target="_blank" to="https://wa.me/919888823721">
              <WhatsAppIcon className="icon" />
            </Link>
          </div>
          <div className="row">
            {/* About Us */}
            <div className="text-start col-12 col-sm-12 col-md-3 col-lg-3 px-4 mb-4">
              <div className="col-12">
                <h6>About Us</h6>
                <p>
                  High Mountains is a modern travel community that provides
                  customized end-to-end travel packages for destinations in
                  India and abroad. Our expertly-designed itineraries encourage
                  group travel for like-minded people and include road trips,
                  trekking expeditions, corporate trips, and tailored tour
                  packages. We prioritize hassle-free traveling and offer
                  top-notch accommodation and guided sightseeing at affordable
                  prices.
                </p>
              </div>
              <div className="col-12">
                <h6>Contact Us</h6>
                <p>
                  ADDRESS: High Mountains New Adarsh Market, Near Mall Road,
                  Manali, Himachal Pradesh 175131
                </p>
              </div>
              <div className="col-12">
                <h6>Social Media Links</h6>
                <div className="social__media__links">
                  <Link
                    target="_blank"
                    to="https://instagram.com/highmountainsin"
                  >
                    <InstagramIcon className="icon" />
                  </Link>
                  <Link target="_blank" to="https://wa.me/919888823721">
                    <WhatsAppIcon className="icon" />
                  </Link>
                  <Link
                    target="_blank"
                    to="https://in.linkedin.com/company/highmountains"
                  >
                    <LinkedInIcon className="icon" />
                  </Link>
                  <Link
                    target="_blank"
                    to="https://www.youtube.com/@highmountainsin"
                  >
                    <YouTubeIcon className="icon" />
                  </Link>
                  <Link
                    target="_blank"
                    to="https://www.facebook.com/Highmountains.in/"
                  >
                    <FacebookIcon className="icon" />
                  </Link>
                  <Link target="_blank" to="">
                    <PinterestIcon className="icon" />
                  </Link>
                </div>
              </div>
            </div>

            {/* Community Trips */}
            <div className="left__border text-start col-12 col-sm-12 col-md-3 col-lg-2 px-4 mb-4">
              <div className="row">
                {homeSliders?.slice(0, 4).map((slider, idx) => (
                  <div key={idx} className="col-6 col-sm-6 col-md-12 col-lg-12">
                    <h6>{slider}</h6>
                    {trips
                      ?.filter((item) => item.category.includes(slider))
                      .reverse()
                      .slice(0, 3)
                      .map((item, index) => (
                        <p
                          onClick={() =>
                            navigate(
                              `/trip/${item?.heading.replace(/\s+/g, "-")}`
                            )
                          }
                          key={index}
                          className="mb-1 footer-blog"
                        >
                          {item?.heading}
                        </p>
                      ))}
                  </div>
                ))}
              </div>
            </div>

            {/* Destinations & Blogs */}
            <div className="left__border text-start col-12 col-sm-12 col-md-3 col-lg-2 px-4 mb-4">
              <div className="row">
                <div className="col-6 col-sm-6 col-md-12 col-lg-12">
                  <h6>Destinations</h6>
                  {destinations?.map((item, index) => (
                    <p
                      onClick={() => navigate(`/category/${item}`)}
                      key={index}
                      className="mb-2 footer-blog"
                    >
                      {item}
                    </p>
                  ))}
                </div>
                <div className="col-6 col-sm-6 col-md-12 col-lg-12">
                  <h6>Our Blogs</h6>
                  {blogs?.slice(0, 4).map((item, index) => (
                    <p
                      key={index}
                      onClick={() => navigate(`/blog/${item?.title}`)}
                      className="footer-blog mb-2"
                    >
                      {item?.title}
                    </p>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="left__border quick__links text-start col-12 col-sm-12 col-md-3 col-lg-3 px-4 mb-4">
              <h4>Quick Links</h4>
              <Link to="/about"><p>About Us</p></Link>
              <Link to="/contact"><p>Contact Us</p></Link>
              <Link to="/blog"><p>Blogs</p></Link>
              <Link to="/reviews"><p>Reviews</p></Link>
              <Link to="/career"><p>Career</p></Link>
              <Link to="/privacy-policy"><p>Privacy Policy</p></Link>
              <Link to="/terms-and-conditions"><p>Terms & Conditions</p></Link>
              <Link to="/refund-policy"><p>Cancellation Policy</p></Link>
            </div>

            {/* Landing Page Links */}
            <div className="left__border landing__links text-start col-12 col-sm-12 col-md-3 col-lg-2 px-4 mb-4">
              <h4>Landing Page Links</h4>
              <Link to="/landing-page-domestic-trips"><p>Domestic Trips</p></Link>
              <Link to="/landing-page-international-trips"><p>International Trips</p></Link>
              {/* <Link to="/landing-page-nye-trips"><p>NYE Trips</p></Link>
              <Link to="/landing-page-nye-domestic-trips"><p>NYE Domestic Trips</p></Link>
              <Link to="/landing-page-all-trips"><p>All Trips</p></Link>
              <Link to="/landing-page-nye-international-trips"><p>NYE International Trips</p></Link>
              <Link to="/landing-page-ladakh-winter-trip"><p>Ladakh Winter Trip</p></Link>
              <Link to="/landing-page-summer-bike-trips"><p>Summer Bike Trips</p></Link>
              <Link to="/landing-page-ladakh-summer-trip-2026"><p>Ladakh Summer Trip 2026</p></Link>
              <Link to="/landing-page-kashmir-winter-trip"><p>Kashmir Winter Trip</p></Link> */}
<Link to="/newyear-trips"><p>New Ads Page</p></Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
